import FilterSearchSortHead from "./FilterSearchSortHead";

export default FilterSearchSortHead;
